module.exports = __webpack_public_path__ + "media/images/del-26a7b5292a837c58e66010094071d537.svg";